<template>
  <div class="auth-form-container">
    <Logo />
    <PasswordResetForm />
    <p class="signup-link"><router-link to="/login">Login</router-link></p>
  </div>
</template>

<script>
import PasswordResetForm from "@/components/molecules/PasswordResetForm";
import Logo from "@/components/atoms/Logo";

export default {
  components: {
    PasswordResetForm,
    Logo,
  },
};
</script>